import React from "react";
import styles from "./STCareer.module.css";
import clsx from "clsx";
import Image from "next/image";
import { careerHeroImg } from "@/assets/images";
import { careersData, whyWorkData } from "@/const/data";
import { Icons } from "@/const/icons";
import { STCareerHero } from "../STCareerHero";
import { useJobs } from "@/hooks";
import { STLoader } from "../STLoader";

import Link from "next/link";

export const STCareer = ({ pageData }) => {
  const { jobs, fetchJobs, loading } = useJobs();

  React.useEffect(() => {
    fetchJobs();
  }, [fetchJobs]);

  const pageContent = pageData?.page?.page_content || {};
  const imageUrlBase = pageData?.imageUrl || "";

  if (loading) return <STLoader />;

  return (
    <>
      <STCareerHero
        title={pageContent.title}
        description={pageContent.description}
        coverPhoto={pageContent.cover_photo}
        imageUrlBase={imageUrlBase}
      />

      <section className={clsx("space-xl-py")}>
        <div className="container">
          {/* Heading */}
          <div
            className={clsx(
              "text-center mx-auto space-md-mb",
              styles.jobHeadingWrapper,
            )}
          >
            <h2 className="primary-title text-clr-gray mb-1">
              Current&nbsp;
              <span className="text-clr-black">opportunities</span>
            </h2>
            <p className={"paragraph-text mb-0"}>
              Be part of a team advancing materials innovation from lab-scale
              research to global deployment. We’re looking for people ready to
              build, learn, and lead.
            </p>
          </div>

          {/* Jobs Wrapper */}
          <div
            className={clsx(
              styles.jobsWrapper,
              "bg-off-white radius-lg space-md-p",
            )}
          >
            {jobs && jobs.length > 0 ? (
              jobs.map((job) => (
                <Link
                  key={job.id}
                  href={`/career/${job.slug}`}
                  className={clsx(
                    styles.jobCard,
                    "cursor-pointer d-block text-decoration-none",
                  )}
                >
                  <div className="d-flex justify-content-between align-items-start gap-xs">
                    {/* Left Content */}
                    <div>
                      <h4 className={"fw-normal space-xs-mb text-clr-black"}>
                        {job.title}
                      </h4>

                      <div className="d-flex align-items-center gap-3 flex-wrap">
                        <div
                          className={clsx(
                            styles.badge,
                            "d-inline-flex align-items-center bg-white gap-3",
                          )}
                        >
                          <span className="text-clr-desire">{Icons.pinIcon}</span>
                          <h6 className="mb-0 fw-normal text-clr-black">
                            {job.location}
                          </h6>
                        </div>

                        <div
                          className={clsx(
                            styles.badge,
                            "d-inline-flex align-items-center bg-white gap-3",
                          )}
                        >
                          <span className="text-clr-boyzone">
                            {Icons.bagIcon}
                          </span>
                          <h6 className="mb-0 fw-normal text-clr-black">
                            {job.type}
                          </h6>
                        </div>
                      </div>
                    </div>

                    {/* Arrow */}
                    <div
                      className={clsx(
                        styles.arrow,
                        "transition-smooth text-clr-black",
                      )}
                    >
                      {Icons.arrowRight}
                    </div>
                  </div>
                </Link>
              ))
            ) : (
              <div className="text-center py-5">
                <h5 className="text-clr-gray fw-normal">No open opportunities at the moment.</h5>
              </div>
            )}
          </div>
        </div>
      </section>

      {/* WHY WORK AT SUSTANIX START */}
      <section className={"bg-black space-xl-py"}>
        <div className="container">
          {/* Heading */}
          <div className={clsx("text-center space-lg-mb")}>
            <h2 className={"primary-title text-clr-white"}>
              Why work at <span className="text-clr-gray-55">Sustanix?</span>
            </h2>
          </div>

          {/* Pills */}
          <div
            className={clsx(
              "d-flex flex-wrap justify-content-center",
              styles.pillWrapper,
            )}
          >
            {whyWorkData.map((item) => {
              return (
                <div
                  key={item.id}
                  className={clsx(
                    styles.pill,
                    "d-flex align-items-center gap-3",
                  )}
                  style={{
                    background: `rgb(${item.color}, 0.15)`,
                    color: `rgb(${item.color}, 1)`,
                    border: `1px solid rgb(${item.color}, 1)`,
                  }}
                >
                  {item.icon}
                  <h6 className="mb-0 fw-normal">{item.title}</h6>
                </div>
              );
            })}
          </div>
        </div>
      </section>
      {/* WHY WORK AT SUSTANIX END */}
    </>
  );
};
